import { Injectable, ComponentRef, createComponent, ApplicationRef, inject, EnvironmentInjector, Type } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    private appRef = inject(ApplicationRef);
    private injector = inject(EnvironmentInjector);

    async open<T>(component: Type<T>, inputs?: Record<string, any>): Promise<boolean> {
        return new Promise((resolve) => {
            // Create modal backdrop
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade in';
            document.body.appendChild(backdrop);

            // Create modal container
            const modalContainer = document.createElement('div');
            modalContainer.className = 'modal fade in';
            modalContainer.style.display = 'block';
            modalContainer.setAttribute('role', 'dialog');
            document.body.appendChild(modalContainer);
            document.body.classList.add('modal-open');

            // Create component
            const componentRef = createComponent(component, {
                environmentInjector: this.injector
            });

            // Set inputs if provided
            if (inputs) {
                Object.keys(inputs).forEach(key => {
                    (componentRef.instance as any)[key] = inputs[key];
                });
            }

            // Attach to app
            this.appRef.attachView(componentRef.hostView);
            const domElem = (componentRef.hostView as any).rootNodes[0] as HTMLElement;
            modalContainer.appendChild(domElem);

            // Handle modal close
            const cleanup = (result: boolean) => {
                this.appRef.detachView(componentRef.hostView);
                componentRef.destroy();
                document.body.removeChild(modalContainer);
                document.body.removeChild(backdrop);
                document.body.classList.remove('modal-open');
                resolve(result);
            };

            // Listen for confirm/cancel from component
            const checkResult = () => {
                const result = (modalContainer as any).confirmResult;
                if (result !== undefined) {
                    cleanup(result);
                }
            };

            // Set up mutation observer to watch for confirmResult changes
            const observer = new MutationObserver(() => {
                checkResult();
            });

            // Also handle clicks on backdrop or close button
            backdrop.addEventListener('click', () => cleanup(false));
            modalContainer.addEventListener('click', (e) => {
                if ((e.target as HTMLElement).classList.contains('close') ||
                    (e.target as HTMLElement).closest('.btn-white')) {
                    cleanup(false);
                } else if ((e.target as HTMLElement).closest('.btn-primary')) {
                    cleanup(true);
                }
            });

            // Detect changes in the component
            componentRef.changeDetectorRef.detectChanges();
        });
    }
}
